import { dataLayer } from "@repo/analytics/data-layer-utils";
import {
  dlEventConstants,
  componentNameConstants,
  dlElementConstants,
} from "@repo/analytics/data-layer.constants";
export const convertChartData = (chartData: string[]) => {
  const cdata = chartData
    ? (chartData.map((d) => ({
        time: Date.parse(d.split(",")[0] ?? "") / 1e3 + 19500 + 300,
        value: parseFloat(d.split(",")[4] ?? "0"),
      })) as any[])
    : [];
  return cdata;
};

export function getDateRange(duration: string) {
  const toDate = new Date();
  const fromDate = new Date(toDate);

  switch (duration) {
    case "1D":
      break;
    case "5D":
      fromDate.setDate(toDate.getDate() - 4);
      break;
    case "1M":
      fromDate.setMonth(toDate.getMonth() - 1);
      break;
    case "3M":
      fromDate.setMonth(toDate.getMonth() - 3);
      break;
    case "6M":
      fromDate.setMonth(toDate.getMonth() - 6);
      break;
    case "1Y":
      fromDate.setFullYear(toDate.getFullYear() - 1);
      break;
    default:
      throw new Error("Invalid duration");
  }

  return {
    fromDate: fromDate.toISOString().split("T")[0],
    toDate: toDate.toISOString().split("T")[0],
  };
}

/**
 * Handles GA tracking for performance graph button clicks
 * @param compName - Company name for section_title
 * @param tabValue - The tab value (button text)
 * @param tabIndex - The position/index of the tab
 */
export const handlePerformanceGraphDL = (
  loginStatus: string,
  compName: string,
  tabValue: string,
  tabIndex: string,
) => {
  const data = {
    section_title: compName,
    component: componentNameConstants.STOCK_PERFORMANCE_GRAPH,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    element: dlElementConstants.STOCK_PERFORMANCE_GRAPH_DURATION_BTN,
    cta_text: tabValue,
    tab_position: tabIndex,
  };

  dataLayer(loginStatus, data);
};
